exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tippy-popper[x-placement^=right] .tippy-tooltip.customTheme-theme .tippy-arrow{border-right:8px solid #346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Charts/SciChartPerDevice.vue"],"names":[],"mappings":"AACA,gFACC,8BAAgC,CAChC","file":"SciChartPerDevice.vue","sourcesContent":["\n.tippy-popper[x-placement^=right] .tippy-tooltip.customTheme-theme .tippy-arrow {\n\tborder-right: 8px solid #346F8B;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7535c33a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Charts/SciChartPerDevice.vue
// module id = 1714
// module chunks = 3 5 6